import { render } from "./MaoSeparator.vue?vue&type=template&id=438e08d0&scoped=true"
import script from "./MaoSeparator.vue?vue&type=script&lang=js"
export * from "./MaoSeparator.vue?vue&type=script&lang=js"

import "./MaoSeparator.vue?vue&type=style&index=0&id=438e08d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438e08d0"]])

export default __exports__